// extracted by mini-css-extract-plugin
module.exports = {"root":"JoyLoader_root__OYfFl","root_hideBackground":"JoyLoader_root_hideBackground__ka84V","path":"JoyLoader_path__I8lQa","draw":"JoyLoader_draw__trwmq"};